module.exports = __webpack_public_path__ + "static/img/wxcode.2dd8d995.png";